/**
 * @author Ka Wing Chin <kawing.chin@takeaway.com>
 * @class Takeaway.Discount
 */

export default class Discount {
  /**
   * @enum Discount types
   * @property {Number} Type.Product specific product discount
   * @property {Number} Type.Nth the n-th when the discount will be applied.
   * @property {Number} Type.Combination combined products discount.
   * @property {Number} Type.Order discount that will always applied or at a minimum total price.
   */
  static Type = Object.freeze({
    Product: 1,
    Nth: 2,
    Combination: 3,
    Order: 4
  })

  /**
   * @property {string} The id of the discount.
   */
  id
  /**
   * @property {int} The type of the discount. Use DiscountType when doing a comparison.
   */
  type
  /**
   * @property {int} The delivery type. Use DeliveryType when doing a comparison.
   */
  deliveryType
  /**
   * @property {string} The name of the discount.
   */
  discountName
  /**
   * @property {string} The description of the discount.
   */
  description
  /**
   * @property {TimeWindow} date the start and end date when the discount is available.
   */
  date
  /**
   * @property {float} A new price when discount is valid.
   */
  specialPrice
  /**
   * @property {float} An amount of discount.
   */
  amount
  /**
   * @property {float} An percentage on the price.
   */
  percentage
  /**
   * @property {int} For each number the discount will be applied.
   */
  number
  /**
   * @property {boolean} Whether the discount is calculated including sidedishes or not.
   */
  inclusiveSidedishes
  /**
   * @property {boolean} Whether the discount can be repeated or not.
   */
  isDiscountRepeat
  /**
   * @property {float} Discount that starts from a specific total price.
   */
  from
  /**
   * @property {array} A group of product ids which discount will be applied on.
   */
  productIds2D

  /**
   * Check if the discount is available according the server time.
   * @property {ServerDateTime} serverDateTime from the server
   * @return {boolean} whether the discount is available or not.
   */
  isAvailable (serverDateTime) {
    // TODO it is unknown how this work in TMS. Do we need to take account the 07:00 rule?
    // TMS only has date. It would better if end time would included 07:00 in the value.
    if (this.date.startTime !== undefined && this.date.endTime !== undefined) {
      if (!serverDateTime.time.isBetween(this.date.startTime, this.date.endTime)) {
        return false
      }
    }

    if (this.date.weekDay === -1 || this.date.weekDay === serverDateTime.weekDay) {
      return true
    }
    return false
  }
}
